import axiosInstance from "../axios/axios-instance";
import { pathAPI } from "../utils/pathApi";
import {
  ApiResponse,
  MenuItemResponse,
  MenuItemCreateRequest,
  MenuItemUpdateRequest,
  MenuItemListResponse,
} from "../@type/menu.types";

export const MenuService = {
  /**
   * Get all menu items with pagination
   */
  getAllMenuItems: (params?: { page?: number; size?: number }) => {
    return axiosInstance.get<MenuItemListResponse>(
      pathAPI.menuItems,
      { params }
    );
  },

  /**
   * Get menu item by ID
   * Returns wrapped response: { success, code, data: MenuItemResponse }
   */
  getMenuItemById: (id: number) => {
    return axiosInstance.get<ApiResponse<MenuItemResponse>>(`${pathAPI.menuItems}/${id}`);
  },

  /**
   * Create new menu item
   * Returns wrapped response: { success, code, data: MenuItemResponse }
   */
  createMenuItem: (data: MenuItemCreateRequest) => {
    return axiosInstance.post<ApiResponse<MenuItemResponse>>(pathAPI.menuItems, data);
  },

  /**
   * Update existing menu item
   * Returns wrapped response: { success, code, data: MenuItemResponse }
   */
  updateMenuItem: (id: number, data: MenuItemUpdateRequest) => {
    return axiosInstance.put<ApiResponse<MenuItemResponse>>(`${pathAPI.menuItems}/${id}`, data);
  },

  /**
   * Delete menu item
   */
  deleteMenuItem: (id: number) => {
    return axiosInstance.delete(`${pathAPI.menuItems}/${id}`);
  },
};
